import { render, staticRenderFns } from "./trading-rules-list.html?vue&type=template&id=641cf23a&scoped=true&external"
import script from "./trading-rules-list.js?vue&type=script&lang=js&external"
export * from "./trading-rules-list.js?vue&type=script&lang=js&external"
import style0 from "./trading-rules-list.scss?vue&type=style&index=0&id=641cf23a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cf23a",
  null
  
)

export default component.exports